import { render, staticRenderFns } from "./RolesCards.vue?vue&type=template&id=3186e243&scoped=true&"
import script from "./RolesCards.vue?vue&type=script&lang=js&"
export * from "./RolesCards.vue?vue&type=script&lang=js&"
import style0 from "./RolesCards.vue?vue&type=style&index=0&id=3186e243&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3186e243",
  null
  
)

export default component.exports